import React, { useState } from 'react';
import { 
  Box, 
  Tabs, 
  Tab, 
  Paper,
  Typography
} from '@mui/material';
import PageTitle from '../components/layout/PageTitle';
import { useAuth } from '../context/AuthContext';
import { USER_ROLES } from '../types/users';

// Import des composants de supervision
import HealthMonitoring from '../components/supervision/HealthMonitoring';
import AuditLogs from '../components/supervision/AuditLogs';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`supervision-tabpanel-${index}`}
      aria-labelledby={`supervision-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const SupervisionPage = () => {
  const { currentUser } = useAuth();
  const [currentTab, setCurrentTab] = useState(0);

  // Vérifier que l'utilisateur est SUPER_ADMIN
  if (currentUser?.role !== USER_ROLES.SUPER_ADMIN) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Accès refusé. Cette page est réservée aux super-administrateurs.
        </Typography>
      </Box>
    );
  }

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // Onglets de supervision pour SUPER_ADMIN uniquement
  const supervisionTabs = [
    {
      label: 'Santé',
      component: <HealthMonitoring />,
      description: 'État des services et performances du serveur'
    },
    {
      label: 'Audit',
      component: <AuditLogs />,
      description: 'Logs d\'audit et traçabilité des actions'
    }
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <PageTitle 
        title="Supervision" 
        subtitle="Monitoring et audit du système"
      />
      
      <Paper sx={{ width: '100%', bgcolor: 'background.paper' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={currentTab} 
            onChange={handleTabChange} 
            aria-label="Onglets de supervision"
            variant="fullWidth"
          >
            {supervisionTabs.map((tab, index) => (
              <Tab 
                key={index}
                label={tab.label} 
                id={`supervision-tab-${index}`}
                aria-controls={`supervision-tabpanel-${index}`}
              />
            ))}
          </Tabs>
        </Box>
        
        {supervisionTabs.map((tab, index) => (
          <TabPanel key={index} value={currentTab} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Paper>
    </Box>
  );
};

export default SupervisionPage;



